import i18n from "src/locales/i18n";

import { BusinessErrorCodes } from "src/types/business-errors";

export const generateUpdateAccountErrorMessage = (e: any) => {

  if (e?.data?.error_code === BusinessErrorCodes.InvalidPhoneNumber) {
    return i18n.t('account.api.profile.invalid_phone_number');
  }

  if (e?.data?.error_code === BusinessErrorCodes.PhoneCountryNotSupported) {
    return i18n.t('account.phone_setup.modal.api.request_verification.country_not_supported');
  }

  return i18n.t('account.api.profile.default_error')
};

export const generateRequestPhoneVerificationErrorMessage = (e: any) => {
  if (e?.data?.error_code === BusinessErrorCodes.InvalidPhoneNumber) {
    return i18n.t('account.api.profile.invalid_phone_number');
  }

  if (e?.data?.error_code === BusinessErrorCodes.PhoneCountryNotSupported) {
    return i18n.t('account.phone_setup.modal.api.request_verification.country_not_supported');
  }

  return i18n.t('account.phone_setup.modal.api.request_verification.default_error');
};


export const generateVerificationErrorMessage = (e: any) => {
  if (e?.data?.error_code === BusinessErrorCodes.PhoneAlreadyVerified) {
    return i18n.t('account.phone_setup.modal.api.verify.already_verified');
  }

  if (e?.data?.error_code === BusinessErrorCodes.PhoneNumberNotSet) {
    return i18n.t('account.phone_setup.modal.api.verify.phone_number_required');
  }

  if (e?.data?.error_code === BusinessErrorCodes.VerificationCodeInvalid || e?.data?.error_code === BusinessErrorCodes.VerificationCodeExpired) {
    return i18n.t('account.phone_setup.modal.api.verify.invalid_code');
  }

  return i18n.t('account.phone_setup.modal.api.request_verification.default_error');
};

export const generateResendErrorMessage = (e: any) => {
  if (e?.data?.error_code === BusinessErrorCodes.NotificationRateLimited) {
    return i18n.t('account.phone_setup.modal.api.resend.rate_limited');
  }

  if (e?.data?.error_code === BusinessErrorCodes.PhoneCountryNotSupported) {
    return i18n.t('account.phone_setup.modal.api.request_verification.country_not_supported');
  }

  return i18n.t('account.phone_setup.modal.api.resend.default_error');
};